<template lang="pug">
  .component-backoffice-category-list.row.column
    .row.column
      base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="false")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'


  export default {
    name: 'DocumentTypeList',
    components: {
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/DocumentType.vue'),
      }
    },
    created() {
    },
    methods: {
      dataLoader(callback) {
        KeplerBackofficeSdk.documentTypes.list().all((data) => {
          var tocs = {
            current_page: 1,
            current_page_count: 1,
            items: [],
            items_count: 10,
            page_count: 1,
            per_page_count: 25,
          }

          tocs.items = data
          tocs.items_count = data.length
          callback(tocs)
        })
      },

    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DocumentTypeList.vue?3d0aacbb